<template>
    <div class="cookie-box" id="cookieBox" v-if="readCookie">
        <div class="cookie-content" v-html="$t('cookie.cookiecontent')">
        </div>
        <div class="cookie-btn-box">
            <button id="closeCookieBtnAgree" @click="closeCookie">{{ $t('cookie.同意') }}</button>
            <button id="closeCookieBtnReject" @click="closeCookie">{{ $t('cookie.拒绝') }}</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            readCookie: false,
        }
    },
    mounted() {
        const hasReadCookie = localStorage.getItem("readcookie");

        if (hasReadCookie === "true") {
            // 如果已经阅读过，隐藏提示框
            this.readCookie = false;
        } else {
            this.readCookie = true;
            // 设置30秒后自动关闭（不修改localStorage）
            const autoCloseTimer = setTimeout(() => {
                this.readCookie = false;
                clearTimeout(autoCloseTimer);
            }, 10000);
        }
    },
    methods: {
        closeCookie() {
            this.readCookie = false;
            localStorage.setItem("readcookie", "true");
        },
    }
}
</script>

<style scoped>
.cookie-box {
    position: fixed;
    bottom: 0;
    left: 0;
    min-height: 95rem;
    padding: 20rem 0;
    width: 100%;
    background-color: #fff;
    color: #888;
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 0 30rem; */
    line-height: normal;
    gap: 30rem;
    z-index: 9999;
}

.cookie-btn-box {
    display: flex;
    gap: 20rem;
}

.cookie-box button {
    /* padding: 20rem; */
    background: none;
    /* color: #888; */
    border: none;
    /* margin: 0 0 0 30rem; */
    font: inherit;
    cursor: pointer;
    outline: inherit;
    font-size: 18rem;
}

#closeCookieBtnAgree {
    display: flex;
    min-width: 110rem;
    height: 35rem;
    padding: 0 20rem 2rem 20rem;
    justify-content: center;
    align-items: center;
    gap: 8rem;
    border-radius: 2px;
    border: 1px solid #a52933;
    background: #a52933;
    color: #fff;
}

#closeCookieBtnReject {
    display: flex;
    min-width: 110rem;
    height: 35rem;
    padding: 0 20rem 2rem 20rem;
    justify-content: center;
    align-items: center;
    gap: 8rem;
    border-radius: 2px;
    border: 1px solid #a52933;
    color: #a52933;
}

.cookie-content {
    max-width: 1227rem;
}

@media (max-width: 996px) {
    .cookie-box {
        flex-direction: column;
        padding: 36rem 60rem 100rem 60rem;
        font-size: 18rem;
    }

    #closeCookieBtnReject,
    #closeCookieBtnAgree {
        font-size: 24rem;
        height: 52rem;
        min-width: 214rem;
    }
}
</style>